"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
interface CalendarLegendProps {
  colorFormat: string;
  content?: string;
}
export default function CalendarLegend(t0) {
  const $ = _c(5);
  const {
    colorFormat,
    content: t1
  } = t0;
  const content = t1 === undefined ? "R\xE9union Club d\u2019Affaires" : t1;
  const t2 = `${colorFormat} ml-2 h-4 inline-block aspect-square rounded-full`;
  let t3;
  if ($[0] !== t2) {
    t3 = <label className={t2} />;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== content || $[3] !== t3) {
    t4 = <p className="flex items-center gap-3">{t3}{" "}{content}</p>;
    $[2] = content;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}